import { Context } from '@nuxt/types'
import localeLoader from '../localeLoader'

export default async (ctx: Context, lang: String) => {
  return await localeLoader(ctx, lang)
}
